<div class="w-12"
     #container></div>
<result class="w-12 p-t-4-s"
        duration="permanent"
        [status]="validateMerchantStatus" />
<!-- busy state presentation -->
@if (displayLoader) {
<div class="flex flex-column w-12 flex-middle m-t-2">
    <i class="icon-loading m-b-2 block w-12 center"></i>
    <span>{{'updating totals...' | translate}}</span>
</div>
}
